import { render, staticRenderFns } from "./IBubbleColor.vue?vue&type=template&id=036d6dd0"
import script from "./IBubbleColor.vue?vue&type=script&lang=js"
export * from "./IBubbleColor.vue?vue&type=script&lang=js"
import style0 from "./IBubbleColor.vue?vue&type=style&index=0&id=036d6dd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports